import React from "react";
import { Redirect } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';

import { withStyles } from '@mui/styles';
import SignUpTemplate from "../components/templates/SignUpTemplate";
import SignUpSteps from "../components/SignUpSteps";
import MixpanelOnload from "../components/MixpanelOnload";
import MixpanelButton from "../components/MixpanelButton";

import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import GA from '../utils/GoogleAnalytics';
const moment = require('moment');

const useStyles = theme => ({
    '@global': {
    },
    paper: {
        padding: '8px',
    },
    'catchIcon': {
        fontSize: '3rem !important',
        marginRight: '10px',
        lineHeight: '6rem'
    },
    'calculatedPrice': {
        fontSize: '2rem',
        fontWeight: 'bold',
    }
});

class SetupPlan extends React.Component {

    constructor() {
        super();
        this.state = {
            redirect: false,
            productName: "Loading",
            hasPlan: false,
            hasPaymentMethod: false,
            isTrial: true,
            startTimestamp: new Date().getTime() / 1000,
            trialEndTimestamp: new Date().getTime() / 1000 + 14 * 24 * 3600 * 1000,
            trialRemains: 14,
            planType: 21,
            productId: 7,
            unitCount: 10,
            // for 
            setPlan: true,
            isOldPlan: false,
            currentUnitCount: 10,
            currentPrice: 30,
            totalPrice: 'loading',
            discountPrice: 30,
            discounted: false,
            nextPaymentDate: '',
        };
        this.getAccount = this.getAccount.bind(this);
    }

    componentDidMount() {
        this.getAccount();
    }

    setCompletePlan() {
        this.setState({
            completePlan: true
        })
    }

    getAccount() {
        fetch('/api/account')
            .then(res => res.json())
            .then(data => {
                // TODO set flags
                console.log(data);
                if (data.planType) {
                    this.setState({ planType: data.planType });
                    this.setState({ productId: data.productId });
                    this.setState({ productName: data.productName });
                    this.setState({ currentUnitCount: data.unitCount });
                    this.setState({ currentPrice: this.getTotalPrice(data.unitCount, false) })
                    this.setState({ nextPaymentDate: moment(data.nextPaymentTimestamp * 1000).format('YYYY-MM-DD') });
                    this.setState({ trialEndDate: moment(data.trialEndTimestamp * 1000).format('YYYY-MM-DD') });
                    this.setState({ hasPlan: true });
                    this.setState({ hasPaymentMethod: data.hasPaymentMethod });
                    this.setState({ isOldPlan: data.isOldPlan });
                    this.setState({ isTrial: data.isTrial });
                    if (this.state.isOldPlan) {
                        this.setState({ setPlan: false });
                        if (this.state.planType === 1) {
                            console.log('set price for personal plan')
                            this.setState({ totalPrice: 35 });
                            this.setState({ currentPrice: 35 });
                        }
                        else {
                            console.log('set price for free plan')
                            this.setState({ totalPrice: 0 });
                            this.setState({ currentPrice: 0 });
                        }
                        return;
                    }
                    else {
                        this.setState({ setPlan: true });
                        this.setUnitCount(data.unitCount);
                    }
                }
                else {
                    this.setState({ hasPlan: false });
                    this.setState({ setPlan: true });
                    this.setState({ isTrial: true });
                    this.setUnitCount(this.state.unitCount);
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ hasPlan: false });
                this.setState({ setPlan: true });
                this.setState({ isTrial: true });
                this.setUnitCount(this.state.unitCount);
            })
    }

    handleSubmit = event => {
        event.preventDefault();
        if (this.state.productId === 1 || this.state.productId === 2) {
            // old type
        }
        GA.Event('Dashboard', 'Change user count', 'setPlan');
        fetch("/api/plan/setPlan", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'planType': this.state.planType,
                'productId': this.state.productId,
                'unitCount': this.state.unitCount,
            })
        })
            .then((res) => {
                console.log(res);
                console.log(this);
                if (res.status === 200) {
                    // do redirect
                    this.setState({ 'redirect': true });
                }
                else {
                    alert('something went wrong, please contact through chat');
                }
            })
            .catch((e) => {
                console.log(e);
                alert(e);
            })
    };

    getTotalPrice = (unitCount, withDiscount = true) => {
        if (withDiscount && unitCount >= 100) {
            return unitCount * 240 / 100;
        }
        return unitCount * 3;
    }

    setUnitCount = (newUnitCount) => {
        this.setState({ unitCount: newUnitCount });
        const price = this.getTotalPrice(newUnitCount, false);
        this.setState({ totalPrice: price });
        this.setState({ discountPrice: price, discounted: false });
        this.setState({ planType: 21 });
        this.setState({ productId: 7 });
        this.setState({ productName: "Enterprise_Monthly" });
    }

    handleInputChange = (event) => {
        const price = parseFloat(event.target.value);
        if (isNaN(price)) return;

        const unitCount = Math.ceil(price / 3);
        this.setState({
            currentPrice: price
        }, () => {
            if (unitCount > 1) {
                this.setUnitCount(unitCount);
            }
        })
    }

    handleBlur = () => {
        if (this.unitCount < 0) {
            this.setUnitCount(0);
        }
    }

    trialAlert = () => {
        const { hasPlan, isTrial, trialEndDate } = this.state;
        return (
            ((hasPlan && isTrial && trialEndDate) ? (
                <Typography className="urgent-notice alert" color="primary" align="right">
                    You're free trial period ends on {trialEndDate}
                </Typography>
            ) : (
                <div></div>
            )
            )
        );
    }

    planSelectForm = () => {
        const { currentPrice } = this.state;
        const mixpanelMessage = 'kiara_app_com_setup_plan_button';
        return (
            <Grid container spacing={4} justify="space-evenly" alignItems="center" justifyContent="center">
                <Grid item md={8} sm={10} align="center">
                    <TextField
                        value={currentPrice}
                        margin="dense"
                        type="number"
                        variant="standard"
                        placeholder="Enter the price"
                        size="medium"
                        sx={{ width: '100%' }}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <span style={{
                                        fontWeight: 'bold',
                                        fontSize: '1.2em',
                                        marginRight: '4px'
                                    }}>
                                        $
                                    </span>
                                </InputAdornment>
                            ),
                        }}
                    /><br />
                    <p align="right">per month</p>
                    <MixpanelButton mixpanelMessage={mixpanelMessage} variant="contained" color="primary" sx={{ width: '50%' }} onClick={this.handleSubmit}>Next</MixpanelButton>
                </Grid>
            </Grid>
        )
    }

    showSteppers = () => {
        const activeStep = 3;
        return <SignUpSteps activeStep={activeStep} />
    }

    prependItems = () => {
        // TODO show trial end date
        return <div>
            {this.trialAlert()}
            {this.showSteppers()}
            <Typography variant="h5" component="h1" align="center" style={{ marginTop: '30px' }} >
                For Customized Enterprise
            </Typography>
            <p align="center" style={{ marginTop: '30px' }} >
                Please input the agreed-upon amount in the email.<br />
                We will contact you as soon as we have verfied the entered amount.
            </p>
        </div>
    }
    appendItems = () => {
        const { isTrial } = this.state;
        return <Grid container spacing={4} justify="space-evenly" alignItems="center" justifyContent="center" >
            <Grid item md={8} sm={10}>
                {isTrial ?
                    <Typography variant="h7" component="p">
                        <ThumbUpAltOutlinedIcon style={{ marginRight: '8px' }}></ThumbUpAltOutlinedIcon>
                        Try free for 14 days
                    </Typography>
                    : <div></div>
                }
                <Typography variant="h7" component="p">
                    <CreditCardIcon style={{ marginRight: '8px' }}></CreditCardIcon>
                    100% Refund Policy.  If you are not satisfied, we are happy to money back.
                </Typography>
            </Grid>
        </Grid>
    }

    // no plan -> urges to select plan
    // no payment -> 
    // under trial -> shows period
    // under free plan -> 
    render() {
        const { redirect } = this.state;
        if (redirect) {
            return <Redirect to="/setup-finish" >
            </Redirect>
        }
        return (
            <SignUpTemplate maxWidth="md" prependItems={this.prependItems()} appendItems={this.appendItems()}>
                <CardContent sx={{ width: '70%' }}>
                    {this.planSelectForm()}
                </CardContent>
                <MixpanelOnload message="kiara-app.com/setup-plan" />
            </SignUpTemplate>
        )
    }
}
export default withStyles(useStyles)(SetupPlan);
